import type { ComponentProps } from 'react';
import type { Badge } from '@cloudflare/kumo';
type BadgeProps = ComponentProps<typeof Badge>;

/** Intenção da conversa (modelo de decisão Laya/Jev): mesmas chaves de backend/src/services/inboxDecision.ts */
export const INTENT_LABEL: Record<string, { label: string; variant: BadgeProps['variant'] }> = {
  vendas: { label: 'Vendas', variant: 'green' },
  suporte: { label: 'Suporte', variant: 'blue' },
  cobranca: { label: 'Cobrança', variant: 'orange' },
  cancelamento: { label: 'Cancelamento', variant: 'red' },
  informacao: { label: 'Informação', variant: 'neutral' },
  outro: { label: 'Outro', variant: 'neutral' },
};

/** Valor do filtro: '' (todas), 'urgent' ou uma intenção */
export function intentFilterParams(v: string): { intent?: string; urgent?: boolean } {
  if (v === 'urgent') return { urgent: true };
  return v && INTENT_LABEL[v] ? { intent: v } : {};
}
